import {Routes} from '@angular/router';
import {HomeComponent} from "./main-pages/home/home.component";
import {RulesComponent} from "./main-pages/rules/rules.component";
import {ContactsComponent} from "./main-pages/contacts/contacts.component";
import {PrivacyPolicyComponent} from "./main-pages/privacy-policy/privacy-policy.component";
import {QaComponent} from "./main-pages/qa/qa.component";
import {environment} from "../../environments/environment";
import {ChatVersions} from "../../../shared/chat.versions";

const landingComponent = () => import('./main-pages/landing/landing.component').then(m => m.LandingComponent)

const landingSlugs = ['free-sex-chat', 'virtual-sex-chat', 'anonymous-chat', 'sexting', 'adult-chat']

// Лендинги существуют только в EN-версии (18sexchat.net). На VT-сборке маршрутов нет вовсе,
// поэтому в RU-бандл не попадают ни они, ни компонент лендинга, а прямой заход по URL
// обрабатывается общим '**' → редиректом на главную.
const landingRoutes: Routes = environment.chatVersion === ChatVersions.SX
    ? landingSlugs.map(slug => ({
        path: slug,
        data: {slug},
        loadComponent: landingComponent
    }))
    : []

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
    },
    {
        path: 'rules',
        component: RulesComponent
    },
    {
        path: 'contacts',
        component: ContactsComponent
    },
    {
        path: 'privacy_policy',
        component: PrivacyPolicyComponent
    },
    {
        path: 'qa',
        component: QaComponent
    },
    {
        path: 'payment-result',
        loadComponent: () => import('./main-pages/payment-result/payment-result.component').then(m => m.PaymentResultComponent)
    },
    {
        path: 'partners',
        loadComponent: () => import('./main-pages/partners/partners.component').then(m => m.PartnersComponent)
    },
    {
        path: 'blog',
        loadComponent: () => import('./main-pages/blog-list/blog-list.component').then(m => m.BlogListComponent)
    },
    {
        path: 'blog/:id',
        loadComponent: () => import('./main-pages/blog-article/blog-article.component').then(m => m.BlogArticleComponent)
    },
    ...landingRoutes,
    {
        path: 'login',
        loadChildren: () => import('./login-module/login.module').then(m => m.LoginModule)
    },
    {
        path: 'auth',
        loadChildren: () => import('./registration-module/registration.module').then(m => m.RegistrationModule)
    },
    {
        path: 'chat',
        loadChildren: () => import('./chat-module/chat.module').then(m => m.ChatModule)
    },
    {
        path: 'test',
        loadChildren: () => import('./test-page-module/test-page-module.module').then(m => m.TestPageModuleModule)
    },
    {path: '**', redirectTo: ''}
]
